import {useState} from "react";
import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {CredentialCreateModal} from "@/pages/vault/vaultForm/CredentialCreateModal.tsx";
import {VaultPageContext} from "@/pages/vault/VaultPageContext.tsx";

import {VaultList} from "./VaultList.tsx";
import {VaultListActions} from "./VaultListActions.tsx";

export const VaultPage = () => {
  const [showCreateCredentialModal, setShowCreateCredentialModal] = useState(false);
  const {user} = useCurrentUserContext();

  return (
    <VaultPageContext.Provider value={{setShowCreateCredentialModal}}>
      <ContentContainer title="Vault" actionsBar={<VaultListActions setShowAddModal={setShowCreateCredentialModal} />}>
        <Helmet>
          <title>Vault</title>
        </Helmet>
        <UpErrorBoundary>
          {user?.has_write_access && (
            <CredentialCreateModal show={showCreateCredentialModal} setShow={setShowCreateCredentialModal} />
          )}
          <VaultList />
        </UpErrorBoundary>
      </ContentContainer>
    </VaultPageContext.Provider>
  );
};
